var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import kfetch from '@kareo/kfetch';
import { FeatureToggles } from '@kareo/billing-system';
import rollbar from 'shared-assets/src/errors/errors';
import featureToggles from 'shared-assets/lib/sdk/featureToggles.js';
import deleteCardOnFile from "shared-assets/components/CreditCardDisplay/deleteCardOnFile";
export default function useSavedCards(_a) {
    var patientId = _a.patientId;
    var _b = useState([]), cards = _b[0], setCards = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    function fetchCardsEffect() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (isLoading)
                    return [2 /*return*/];
                setIsLoading(true);
                featureToggles
                    .isEnabled(FeatureToggles.TEBRA_PAYFAC_PASS_THROUGH_ONLY)
                    .then(function (isTebraPayFacPassThroughOnly) {
                    var cardsURL = '/payments-ui/api/PatientPay/';
                    var getCardsURL = isTebraPayFacPassThroughOnly ? cardsURL + 'payments-orchestrator-service/api/customer/lid/' + patientId + '/cards' : cardsURL + 'cards/' + patientId;
                    kfetch(getCardsURL)
                        .then(function (resp) {
                        setCards(resp);
                    })
                        .finally(function () { return setIsLoading(false); })
                        .catch(function (err) { return rollbar.error(err); });
                });
                return [2 /*return*/];
            });
        });
    }
    function deleteCard(cardId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, deleteCardOnFile(patientId.toString(), cardId)];
                    case 1:
                        response = _a.sent();
                        if (response.deleteSuccessful) {
                            setCards(cards.filter(function (card) { return card.cardId.toString() !== cardId; }));
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        rollbar.error(new Error('Error while deleting card.'));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        fetchCardsEffect();
    }, []);
    return {
        cards: cards,
        isLoading: isLoading,
        deleteCard: deleteCard,
    };
}
